import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

export enum ProgressionState {
    START,
    PERSONAL_DETAILS,
    CREATE_PASSWORD,
    CONTACT_DETAILS,
    MOBILE_VALIDATION,
    ACCOUNT_CREATED,
    LOGIN,
    ACCOUNT_VALIDATED
}

const ProgressionStateNames: { [key in ProgressionState]: string } = {
    [ProgressionState.START]: 'start',
    [ProgressionState.PERSONAL_DETAILS]: 'personal_details',
    [ProgressionState.CREATE_PASSWORD]: 'create_password',
    [ProgressionState.CONTACT_DETAILS]: 'contact_details',
    [ProgressionState.MOBILE_VALIDATION]: 'mobile_validation',
    [ProgressionState.ACCOUNT_CREATED]: 'account_created',
    [ProgressionState.LOGIN]: 'login',
    [ProgressionState.ACCOUNT_VALIDATED]: 'account_validated'
} as const;

@Injectable({
    providedIn: 'root'
})
export class ProgressionService {
    constructor(private ls: LocalStorageService) { }

    advanceTo(state: ProgressionState, requirement?: ProgressionState): void {
        const currentStateName = this.ls.getLS('experience_last_page');
        const currentState = this.getStateByName(currentStateName);

        // New state is not further progressed than the current one
        if (state <= currentState) return;
        if (requirement && currentState < requirement) return;

        this.ls.setLS('experience_last_page', ProgressionStateNames[state]);
    }

    getStateByName(name: string): ProgressionState {
        return Number(Object.keys(ProgressionStateNames).find(x => ProgressionStateNames[Number(x)] === name)) as ProgressionState;
    }
    
    getCurrentStateName(): string {
        return this.ls.getLS('experience_last_page');
    }

    getPercentage(): number {
        const currentState = this.getCurrentStateName();
        const steps = Object.keys(ProgressionStateNames);
        const currentKey = steps.find(x => ProgressionStateNames[x] === currentState);
        const currentIndex = steps.indexOf(currentKey) + 1;        

        return (currentIndex / steps.length) * 100;
    }
}
